import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { FC } from 'react';
import { Provider } from 'react-redux';

import { IApplicationContext } from 'shared/types/applicationContext';
import { TReduxStore } from 'shared/types/redux';
import { ApplicationContext } from 'shared/utils/applicationContext';

import { FloorPlan } from '../FloorPlan';
import { GenplanContainer } from '../Genplan';
import { BreadCrumbs } from '../BreadCrumbs';
import { SeoLinksContainer } from '../SeoLinks/SeoLinksContainer';
import { PageTitleContainer } from '../PageTitle/PageTitle';
import { TitleSection } from '../../components/TitleSection/TitleSection';
import { FixedHeader } from '../FixedHeader';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export const Application: FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { initialDeviceType },
  } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={initialDeviceType}>
          <Provider store={reduxStore}>
            <FixedHeader />
            <BreadCrumbs />
            <TitleSection>
              <SeoLinksContainer />
              <PageTitleContainer />
            </TitleSection>
            <GenplanContainer />
            <FloorPlan />
          </Provider>
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
